import React from "react";
/* eslint-disable */
import {
  Box, TableBody, TableCell, TableContainer, TableHead, TableRow, Table
} from '@material-ui/core';
import moment from "moment";

export default class ComponentToPrint extends React.Component {

  render() {
    const reportData = this.props.reportData;
    const data = this.props.searchData;
    const totalValues = this.props.totalValues;
    return (
      <div align='left' style={{ padding: '15px' }}>
        <h3><center><u>Quantity Variance FCC IQ Vs OQ Report</u></center></h3>
        <div >&nbsp;</div>
        <div>&nbsp;</div>
        <Box >
          <TableContainer style={{ marginLeft: '5px' }}>
            <Table aria-label="caption table">
              <TableHead>
                <TableRow>
                  <TableCell colSpan={4} align='center' style={{ fontWeight: 'bold', border: "1px solid black", backgroundColor: '#caedfb' }}>Order Details</TableCell>
                  <TableCell colSpan={4} align='center' style={{ fontWeight: 'bold', border: "1px solid black", backgroundColor: '#fbe2d5' }}>Inbound Quantity</TableCell>
                  <TableCell colSpan={4} align='center' style={{ fontWeight: 'bold', border: "1px solid black", backgroundColor: '#daf2d0' }}>Outbound Quantity</TableCell>
                  <TableCell rowSpan={2} align='center' style={{ fontWeight: 'bold', border: "1px solid black", backgroundColor: '#e49edd' }}>Variance</TableCell>
                </TableRow>
                <TableRow>
                  <TableCell style={{ fontWeight: 'bold', border: "1px solid black", backgroundColor: '#61cbf3' }}>FCC</TableCell>
                  <TableCell style={{ fontWeight: 'bold', border: "1px solid black", backgroundColor: '#61cbf3' }}>SKU Code</TableCell>
                  <TableCell style={{ fontWeight: 'bold', border: "1px solid black", backgroundColor: '#61cbf3' }}>SKU Description</TableCell>
                  <TableCell style={{ fontWeight: 'bold', border: "1px solid black", backgroundColor: '#61cbf3' }}>Order Number</TableCell>
                  <TableCell style={{ fontWeight: 'bold', border: "1px solid black", backgroundColor: '#e9a37f' }}>Weighted Date</TableCell>
                  <TableCell style={{ fontWeight: 'bold', border: "1px solid black", backgroundColor: '#e9a37f' }}>Weighted Qty</TableCell>
                  <TableCell style={{ fontWeight: 'bold', border: "1px solid black", backgroundColor: '#e9a37f' }}>GRN Price</TableCell>
                  <TableCell style={{ fontWeight: 'bold', border: "1px solid black", backgroundColor: '#e9a37f' }}>GRN Amount</TableCell>
                  <TableCell style={{ fontWeight: 'bold', border: "1px solid black", backgroundColor: '#b5e6a2' }}>GTN Date</TableCell>
                  <TableCell style={{ fontWeight: 'bold', border: "1px solid black", backgroundColor: '#b5e6a2' }}>GTN Number</TableCell>
                  <TableCell style={{ fontWeight: 'bold', border: "1px solid black", backgroundColor: '#b5e6a2' }}>Vehicle Number</TableCell>
                  <TableCell style={{ fontWeight: 'bold', border: "1px solid black", backgroundColor: '#b5e6a2' }}>GTN Quantity</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {reportData.map((row, index) => {
                  const hasOutBound = row.outBound && row.outBound.length > 0;
                  const variance = row.variance;

                  return (
                    <React.Fragment key={index}>
                      <TableRow>
                        <TableCell style={{ border: "1px solid black" }} rowSpan={hasOutBound ? row.outBound.length : 1}>
                            {row.factoryName}
                        </TableCell>
                        <TableCell style={{ border: "1px solid black" }} rowSpan={hasOutBound ? row.outBound.length : 1}>
                          {row.skuCode}
                        </TableCell>
                        <TableCell style={{ border: "1px solid black" }} rowSpan={hasOutBound ? row.outBound.length : 1}>
                          {row.skuDes}
                        </TableCell>
                        <TableCell style={{ border: "1px solid black" }} rowSpan={hasOutBound ? row.outBound.length : 1}>
                          {row.orderNo}
                        </TableCell>

                        {row.inBound.map((column, colIndex) => (
                          <React.Fragment key={`inbound-${colIndex}`}>
                            <TableCell style={{ border: "1px solid black" }} rowSpan={hasOutBound ? row.outBound.length : 1}>
                              {moment(column.weightedDate).format("YYYY-MM-DD")}
                            </TableCell>
                            <TableCell style={{ border: "1px solid black" }} rowSpan={hasOutBound ? row.outBound.length : 1} align="right">
                              {column.weightedQty == 0 || null ? "-" : parseFloat(column.weightedQty).toLocaleString("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                            </TableCell>
                            <TableCell style={{ border: "1px solid black" }} rowSpan={hasOutBound ? row.outBound.length : 1} align="right">
                              {column.grnPrice == 0 || null ? "-" : parseFloat(column.grnPrice).toLocaleString("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                            </TableCell>
                            <TableCell style={{ border: "1px solid black" }} rowSpan={hasOutBound ? row.outBound.length : 1} align="right">
                              {column.grnAmount == 0 || null ? "-" : parseFloat(column.grnAmount).toLocaleString("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                            </TableCell>
                          </React.Fragment>
                        ))}

                        {hasOutBound ? (
                          <>
                            <TableCell style={{ border: "1px solid black", whiteSpace: "nowrap" }}>{moment(row.outBound[0].gtnDate).format("YYYY-MM-DD")}</TableCell>
                            <TableCell style={{ border: "1px solid black" }}>{row.outBound[0].gtnNumber}</TableCell>
                            <TableCell style={{ border: "1px solid black" }}>{row.outBound[0].vehicleNumber}</TableCell>
                            <TableCell style={{ border: "1px solid black" }} align="right">
                              {row.outBound[0].gtnQty == 0 || null ? "-" : parseFloat(row.outBound[0].gtnQty).toLocaleString("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                            </TableCell>
                            <TableCell style={{ border: "1px solid black" }} rowSpan={hasOutBound ? row.outBound.length : 1} align="right">
                              {variance === 0 ? "-" : parseFloat(variance).toLocaleString("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                            </TableCell>
                          </>
                        )
                          : (
                            <>
                              <TableCell colSpan={4} align="center" style={{ border: "1px solid black" }}>-</TableCell>
                              <TableCell style={{ border: "1px solid black" }} rowSpan={hasOutBound ? row.outBound.length : 1} align="right">
                                {variance === 0 ? "-" : parseFloat(variance).toLocaleString("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                              </TableCell>
                            </>
                          )}
                      </TableRow>

                      {hasOutBound &&
                        row.outBound.slice(1).map((outBoundRow, outIndex) => (
                          <TableRow key={`outbound-${outIndex}`}>
                            <TableCell style={{ border: "1px solid black", whiteSpace: "nowrap" }}>{moment(outBoundRow.gtnDate).format("YYYY-MM-DD")}</TableCell>
                            <TableCell style={{ border: "1px solid black" }}>{outBoundRow.gtnNumber}</TableCell>
                            <TableCell style={{ border: "1px solid black" }}>{outBoundRow.vehicleNumber}</TableCell>
                            <TableCell style={{ border: "1px solid black" }} align="right">
                              {outBoundRow.gtnQty == 0 || null ? "-" : parseFloat(outBoundRow.gtnQty).toLocaleString("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                            </TableCell>
                          </TableRow>
                        ))}
                    </React.Fragment>
                  );
                })}
                <TableRow>
                  <TableCell sx={{ fontWeight: "bold", border: "1px solid black" }} colSpan={5}>Total</TableCell>
                  <TableCell sx={{ fontWeight: "bold", border: "1px solid black" }} align="right">{totalValues.totalweightedQty == 0 ? "-" : parseFloat(totalValues.totalweightedQty).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</TableCell>
                  <TableCell style={{ border: "1px solid black" }} align="right"></TableCell>
                  <TableCell sx={{ fontWeight: "bold", border: "1px solid black" }} align="right">{totalValues.totalgrnAmount == 0 ? "-" : parseFloat(totalValues.totalgrnAmount).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</TableCell>
                  <TableCell style={{ border: "1px solid black" }} align="right" colSpan={3}></TableCell>
                  <TableCell sx={{ fontWeight: "bold", border: "1px solid black" }} align="right">{totalValues.totalGtnQty == 0 ? "-" : parseFloat(totalValues.totalGtnQty).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</TableCell>
                  <TableCell sx={{ fontWeight: "bold", border: "1px solid black" }} align="right">{totalValues.totalVariance == 0 ? "-" : parseFloat(totalValues.totalVariance).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</TableCell>
                </TableRow>
              </TableBody>
            </Table>
          </TableContainer>
        </Box>
      </div>
    );
  }
}
